import { Component, Input, ViewChild } from '@angular/core';
import { UrlSegment } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormControl, FormBuilder, Validators } from "@angular/forms"
import { faEdit, faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons';
import { GridApi } from 'ag-grid-community';
import { Observable, map } from 'rxjs';
import { startWith } from 'rxjs/operators';
import * as SelectList from '../select-options';
import { DatePipe, CommonModule } from '@angular/common';
import { LadingStatusModalComponent } from 'src/app/lading-status-modal/lading-status-modal.component';
import { ScheduledTimeModalComponent } from 'src/app/scheduled-time-modal/scheduled-time-modal.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ShipmentListsModalComponent } from '../../shipment-lists/shipment-lists-modal/shipment-lists-modal.component';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements ICellRendererAngularComp {
  // Modal to add lading status
  @ViewChild(LadingStatusModalComponent) lading_status_modal!: LadingStatusModalComponent;
  @ViewChild('statusDialog') statusDialog!: HTMLDialogElement;
  isStatusModalOpen: boolean = false;
  openStatusModal() { this.isStatusModalOpen = true; }
  closeStatusModal(update_successful: any) { 
    this.isStatusModalOpen = false; 
    if (update_successful == 1){
      this.toastr.success("Status successfully updated!");
      this.fetchAdditionalInfo(); // refresh data without nuking the page
    } else if (update_successful == 2){
      this.toastr.error("Status was not updated.");
    }
  }

  // Modal to change date/time
  @ViewChild(ScheduledTimeModalComponent) datetime_modal!: ScheduledTimeModalComponent;
  isDatetimeModalOpen: boolean = false;
  openPickupModal() { this.isDatetimeModalOpen = true; }
  closePickupModal(savingChanges: boolean) { 
    this.isDatetimeModalOpen = false; 
    // if(savingChanges){
    //   location.reload()
    // }
  }

  // Modal to change date/time
  @ViewChild(ScheduledTimeModalComponent) delivery_modal!: ScheduledTimeModalComponent;
  isDeliveryeModalOpen: boolean = false;
  openDeliveryModal() { this.isDeliveryeModalOpen = true; }
  closeDeliveryModal(savingChanges: boolean) { 
    this.isDeliveryeModalOpen = false; 
    // if(savingChanges){
    //   location.reload()
    // }
  }

  // Modal to change date/time
  @ViewChild(ScheduledTimeModalComponent) appointment_modal!: ScheduledTimeModalComponent;
  isAppointmentModalOpen: boolean = false;
  openAppointmentModal() { this.isAppointmentModalOpen = true; }
  closeAppointmentModal(savingChanges: boolean) { 
    this.isAppointmentModalOpen = false; 
    // if(savingChanges){
    //   location.reload() 
    // }
  }

  removeAppointment(){
    const url = "/api/work_orders/appointment_unset.php";
    this.http.post<any>(url, { "lading_uuid": this.lading_uuid }).subscribe(
      response => {
        console.log('remove appointment response: ' + response);
        this.toastr.success('Appointment removed.');
      },
      error => {
        console.log('error removing appointment');
        console.log(error)
        this.toastr.error('Error removing appointment.');
      }
    )
  }

  // FontAwesome icons
  edit_icon = faEdit;
  cancel_icon = faXmark;
  save_icon = faFloppyDisk;

  edit_all_tabs: boolean = false; // determines visibility of edit buttons

  // For switching carrier
  carrierList: any[] = [];
  new_carrier_forms = this.fb.group({
    carrier_contact_control: { value: '', disabled: true },
    carrier_contact_uuid: { value: '', disabled: true },
    old_carrier_task_uuid: { value: '', disabled: true },
    carrier_address_uuid: { value: '', disabled: true }
  })
  filteredCarrierList: Observable<string[]> | undefined; // gets displayed in dropdown
  carrier_selected_uuid: string = '';
  carrierAddresses: string[] = ['Select Carrier First'];
  carrierFullList: any[] | undefined;

  apiUrl = '';
  lading_uuid: string = '';
  trip_number: string = ''; // used for print buttons

  addresses: Addresses = { shipper: [], consignee: [] };
  consignee_contact_uuid: string = ''; // to open map
  shipper: any = {};
  consignee: any = {};
  customer: any = {};
  ops_checks: any = {};
  sales: any = {};
  admin: any = {};
  care: any = {};
  // need these for post body
  shipper_site_check_uuid: string = '';
  consignee_site_check_uuid: string = '';
  customer_site_check_uuid: string = '';

  // stuff for new plugin
  details: any = {};
  lading_details: any = {};

  // Lading statuses
  lading_statuses: LadingStatus[] = [];
  lading_status_form = this.fb.group({
    status: ['', Validators.required],
    date: [new Date(), Validators.required],
    time: ['00:00', Validators.required]
  })
  lading_status_options = SelectList.STATUSES;

  order_summary_forms = this.fb.group({
    load_start_date: new FormControl({ value: new Date(), disabled: true }),
    load_start_time: new FormControl({ value: '', disabled: true }),
    load_end_date: new FormControl({ value: new Date(), disabled: true }),
    load_end_time: new FormControl({ value: '', disabled: true }),
    load_details: new FormControl({ value: '', disabled: true }),
    seal_number: new FormControl({ value: '', disabled: true }),
    hot: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    drop_trailer: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    expedited: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    customer_po: new FormControl({ value: '', disabled: true })
  })

  ops_forms = this.fb.group({
    carrier_rated: new FormControl({ value: false, disabled: true }, Validators.nullValidator), // validator allows value to be null
    carrier_rerated: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    straps_bars: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    lift_lull: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    call_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    protective_equipment: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    unmanned_job_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    operations_notation: new FormControl({ value: '', disabled: true }),
    // fields below this line are KPIs
    loaded_odot: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    loading_delay: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    document_delay: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    border_delay: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    customs_inspection: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    trailer_unavailable: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    driver_unavailable: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    driver_hos: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    carrier_reneged: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    mechanical_delay: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    trailer_switch: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    weather_delay: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    dock_waiting: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    dock_re_delivery: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    scheduled_holiday: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
  })

  renege_reason: { [key: number]: string } = {
    1: 'Wrong Equipment',
    2: 'Unserviced Area',
    3: 'Capacity Issue',
    4: 'Equipment Breakdown',
    5: 'Traffic',
    6: 'Route Disruptions',
    7: 'Regulatory Issues',
    8: 'Safety Concerns',
    9: 'Overbooking',
    10: 'Documentation Errors',
    11: 'Legal Restrictions',
    12: 'Cargo Security Issues',
    13: 'Labour Disputes',
    14: 'Fuel Shortages',
    15: 'Communication Failures',
    16: 'Unexpected Cargo Content',
    17: 'Environmental Restrictions',
    18: 'Driver Availability'
  }
  carrier_reneged_form = this.fb.group({
    did_carrier_reneged: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    carrier_reneged_reason: new FormControl({ value: 0, disabled: false }, Validators.nullValidator)
  })

  cares_forms = this.fb.group({
    confirm_pick_up: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    confirm_delivery: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    pod_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    purchase_order_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    care_notation: new FormControl({ value: '', disabled: true })
  })

  shipper_forms = this.fb.group({
    pickup_reference_number_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    pickup_reference_number: new FormControl({ value: '', disabled: true }),
    loading_dock: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    pickup_tailgate: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    truck_space: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    appointment: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    call_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    shipping_bol_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    commercial: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    residential: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    job_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    unmanned_job_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    job_site_contact_name: new FormControl({ value: '', disabled: true }),
    job_site_contact_phone: new FormControl({ value: '', disabled: true }),
    appointment_contact_name: new FormControl({ value: '', disabled: true }),
    appointment_contact_phone: new FormControl({ value: '', disabled: true }),
    notification_at_pickup: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_delayed_pickup: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_at_delivery: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_delayed_delivery: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_assessorials_incured: new FormControl({ value: false, disabled: true }, Validators.nullValidator)
  })

  consignee_forms = this.fb.group({
    delivery_reference_number_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    delivery_reference_number: new FormControl({ value: '', disabled: true }),
    loading_dock: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    pickup_tailgate: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    truck_space: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    appointment: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    call_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    commercial: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    residential: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    job_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    unmanned_job_site: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    convention_center: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    pop_up_store: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    job_site_contact_name: new FormControl({ value: '', disabled: true }),
    job_site_contact_phone: new FormControl({ value: '', disabled: true }),
    appointment_contact_name: new FormControl({ value: '', disabled: true }),
    appointment_contact_phone: new FormControl({ value: '', disabled: true }),
    notification_at_pickup: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_delayed_pickup: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_at_delivery: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_delayed_delivery: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    notification_assessorials_incured: new FormControl({ value: false, disabled: true }, Validators.nullValidator)
  })

  customer_forms = this.fb.group({
    bol_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    invoice_bol_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    rate_quote_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    invoice_po_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    invoice_po: new FormControl({ value: '', disabled: true }),
    pickup_reference_number_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    delivery_reference_number_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
  })

  sales_forms = this.fb.group({
    quote_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    requote_required: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    customer_rated: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    sales_notation: new FormControl({ value: '', disabled: true }),
    management_notation: new FormControl({ value: '', disabled: true }),
  })

  admin_forms = this.fb.group({
    po_audited: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    confirm_charges: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    freight_cost_approved: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    ready_invoice: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    intent_claim: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    invoice_thanks: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    pod_audited: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    carrier_invoiced: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    freight_cost_exception: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    damage_claim: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    claim_review: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
    invoice_due: new FormControl({ value: false, disabled: true }, Validators.nullValidator),
  })

  constructor(private http: HttpClient, private fb: FormBuilder, private toastr: ToastrService, private dialog: MatDialog) {
    this.lading_status_form.get('status')!.valueChanges.subscribe(value => {
      let dateNeeded = ['Arrived Shipper', 'Loading Shipper', 'Loaded Shipper', 'En Route Consignee', 'Arrived Consignee', 'Unloading Consignee', 'Delivered Consignee'];
      if (value != null && dateNeeded.indexOf(value) > -1) {
        this.lading_status_form.get('date')!.setValidators([Validators.required]);
        this.lading_status_form.get('time')!.setValidators([Validators.required]);
      }
      else {
        this.lading_status_form.get('date')!.clearValidators();
        this.lading_status_form.get('time')!.clearValidators();
      }
    })
  }

  cancelLading(){

  }

  convertTo24Hr(timeString: any): string {
    // Parse the time string
    const parts = timeString.split(':');
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1].split(' ')[0]);
    const period = parts[1].split(' ')[1];

    // Adjust hours if necessary
    let formattedHours = hours;
    if (period === 'PM' && hours < 12) {
      formattedHours += 12;
    } else if (period === 'AM' && hours === 12) {
      formattedHours = 0;
    }

    // Format hours and minutes with leading zeros
    const formattedTime = this.padZero(formattedHours) + ':' + this.padZero(minutes);

    return formattedTime;
  }

  // Converts a Date to string of mm/dd/yyyy format
  convertDate(date: any) {
    // Get day, month, and year from dateObject
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month is 0-based
    const year = date.getFullYear();

    // Construct the formatted date string
    const formattedDate = this.padZero(month) + '/' + this.padZero(day) + '/' + year;

    return formattedDate;
  }

  // Helper function to pad single-digit numbers with a leading zero
  padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  // submitNewStatus() {
  //   let status = this.lading_status_form.get('status')?.value;
  //   if (status != null && this.lading_status_options.indexOf(status) > -1) {
  //     if (typeof this.lading_status_form.get('time')?.value == 'string') {
  //       let formattedDateString = this.convertDate(this.lading_status_form.get('date')?.value)
  //       let formattedTimeString = this.convertTo24Hr(this.lading_status_form.get('time')?.value)
  //       let postData = {
  //         lading_uuid: this.lading_uuid,
  //         lading_status: status,
  //         selected_date: formattedDateString,
  //         selected_time: formattedTimeString
  //       }
  //       this.http.post<any>('/api/lading_status/add_lading_status.php', postData).subscribe(
  //         (response) => {
  //           console.log('Lading status updated.');
  //         },
  //         (error) => {
  //           console.error('Ladging status not updated: ', error);
  //         }
  //       )
  //     }
  //   }
  //   else {
  //     let postData = {
  //       lading_uuid: this.lading_uuid,
  //       lading_status: status
  //     }
  //     this.http.post<any>('/api/lading_status/add_lading_status.php', postData).subscribe(
  //       (response) => {
  //         console.log('Lading status updated.');
  //       },
  //       (error) => {
  //         console.error('Ladging status not updated: ', error);
  //       }
  //     )

  //   }

  // }

submitNewStatus() {
    const status = this.lading_status_form.get('status')?.value;
    if (!status) {
      this.toastr.warning('No status selected.', 'Status Update');
      return;
    }

    // Only run conversions if both date and time fields exist
    const dateControl = this.lading_status_form.get('date')?.value;
    const timeControl = this.lading_status_form.get('time')?.value;

    let formattedDateString: string | null = null;
    let formattedTimeString: string | null = null;

    if (typeof timeControl === 'string' && dateControl) {
      formattedDateString = this.convertDate(dateControl);
      formattedTimeString = this.convertTo24Hr(timeControl);
    }

    const postData: any = {
      lading_uuid: this.lading_uuid,
      lading_status: status,
      UFOS_update: true
    };

    if (formattedDateString && formattedTimeString) {
      postData.selected_date = formattedDateString;
      postData.selected_time = formattedTimeString;
    }

    this.http.post<any>('/api/lading_status/add_lading_status.php', postData).subscribe({
      next: (res) => {
        console.log('Lading status updated:', res);
        this.toastr.success(
          `Status updated to "${status}" successfully.`,
          'Lading Status Updated'
        );

        // Update timeline immediately
        const now = new Date();
        const localDate = formattedDateString || now.toISOString().substring(0, 10);
        const localTime = formattedTimeString || now.toISOString().substring(11, 16);

        this.lading_statuses.unshift({
          lading_status: status,
          local_time: `${localDate} ${localTime}`,
          created: now.toISOString()
        });

        // Close the modal if open
        if (this.statusDialog?.close) {
          this.statusDialog.close();
        }
        this.isStatusModalOpen = false;
      },
      error: (err) => {
        console.error('Lading status not updated:', err);
        this.toastr.error(
          'There was a problem updating the lading status.',
          'Update Failed'
        );
      }
    });
  }




  agInit(params: any) {
    if (params.data) {
      console.log(Object.keys(params))
      this.lading_uuid = params.data.lading_uuid;
      this.apiUrl = `/api/work_orders/new_work_order_grid_details.php?uuid=${this.lading_uuid}`
      this.trip_number = params.data.trip_number;
      console.log(this.lading_uuid)
      //this.gridApi = params.api;
      this.fetchAdditionalInfo();
    }

  }

  ngOnInit() {
    this.new_carrier_forms.get('carrier_contact_control')?.valueChanges.subscribe((data) => {
      // if user enters 3+ characters in carrier input field, get a list of carriers
      if (data != null && data.length >= 3) {
        this.getCarrierList().subscribe((data) => this.carrierList = data)
      }
      const index = this.carrierFullList?.findIndex((item: any) => item.label === data);
      // if input matches a carrier, set carrier uuid and get list of addresses
      if (index !== -1 && this.carrierFullList && index !== undefined) {
        this.carrier_selected_uuid = this.carrierFullList[index]?.value;
        this.new_carrier_forms.get('carrier_contact_uuid')?.setValue(this.carrier_selected_uuid);
        if (this.carrier_selected_uuid) {
          this.carrierAddressList().subscribe(data => {
            this.carrierAddresses = data;
          })
        }
      }
    });
    // filter the carrier list for displaying
    this.filteredCarrierList = this.new_carrier_forms.get('carrier_contact_control')?.valueChanges.pipe(
      startWith(''),
      map(carrierList => carrierList ? this.filterCarrierList(carrierList) : this.carrierList.slice())
    )
  }

  // populate list of carriers
  getCarrierList(): Observable<string[]> {
    console.log('getCarrierList executing')
    let searchText = this.new_carrier_forms.get('carrier_contact_control')?.value;
    let url = `/api/work_orders/contact_autofill.php?type=carrier_contact_list&search=${searchText}`
    return this.http.get<any[]>(url).pipe(
      map(response => {
        if (response) {
          this.carrierFullList = response;
          this.carrierList = response.map(item => item.label)
          console.log(this.carrierList);
          return response.map(item => item.label)
        }
        else {
          console.log(`search text: ${searchText}`)
          this.carrierList = [];
          return [];
        }
      })
    )
  }

  // populate list of addresses for selected carrier
  carrierAddressList(): Observable<string[]> {
    if (this.carrier_selected_uuid) {
      return this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${this.carrier_selected_uuid}`)
        .pipe(
          map(response => {
            this.new_carrier_forms.get('carrier_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
            console.log('carrier_address_uuid: ' + this.new_carrier_forms.get('carrier_address_uuid')?.value);
            return response[0].addresses.map((item: any) => item.address + ' - ' + item.locality + ' - ' + item.region);
          })
        );
    }
    return new Observable<string[]>();
  }

  filterCarrierList(name: string) {
    return this.carrierList.filter(carrierList =>
      carrierList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  submitNewCarrier() {
    // formData won't be set properly with this.new_carrier_forms.value for some reason
    let formData: any = { carrier_contact_uuid: '', carrier_address_uuid: '', old_carrier_task_uuid: '' };
    formData.carrier_contact_uuid = this.new_carrier_forms.get('carrier_contact_uuid')?.value;
    formData.carrier_address_uuid = this.new_carrier_forms.get('carrier_address_uuid')?.value;
    formData.old_carrier_task_uuid = this.new_carrier_forms.get('old_carrier_task_uuid')?.value;

    this.http.post<any>(`/api/work_orders/set_carrier.php?lading_uuid=${this.lading_uuid}`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('Form submitted successfully', response);
        location.reload();
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the form', error);
      }
    );
  }

  // set shipper and consignee addresses
  setAddresses() {
    if (this.details.shipper.address) {
      this.addresses['shipper'] = this.buildAddress(this.details.shipper.address)
    }
    if (this.details.consignee.address) {
      this.addresses['consignee'] = this.buildAddress(this.details.consignee.address)
    }

  }

  // set initial date values
  setFormControlDates() {
    if (this.details.ladings.load_start === null) {
      this.order_summary_forms.get('load_start_date')?.setValue(null);
    }
    else {
      let dateParts = this.details.ladings.load_start.substring(0, 10).split('-');
      let newDateFormat = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
      if (dateParts[0] == '1969' || dateParts[0] == '1970') {
        this.order_summary_forms.get('load_start_date')?.setValue(null);
      }
      else {
        this.order_summary_forms.get('load_start_date')?.setValue(new Date(newDateFormat));
      }
      this.order_summary_forms.get('load_start_time')?.setValue(this.details.ladings.load_start.substring(11, 16))
    }

    if (this.details.ladings.load_end === null) {
      this.order_summary_forms.get('load_end_date')?.setValue(null);
    }
    else {
      let dateParts = this.details.ladings.load_end.substring(0, 10).split('-');
      let newDateFormat = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
      if (dateParts[0] == '1969' || dateParts[0] == '1970') {
        this.order_summary_forms.get('load_end_date')?.setValue(null);
      }
      else {
        this.order_summary_forms.get('load_end_date')?.setValue(new Date(newDateFormat));
      }
      this.order_summary_forms.get('load_end_time')?.setValue(this.details.ladings.load_end.substring(11, 16))
    }
  }

  setFormControlValues() {
    // lists of keys in the api, used to name and set values for form controls
    const cares_fields = ['confirm_pick_up', 'confirm_delivery', 'pod_required', 'purchase_order_required', 'care_notation'];
    const sales_fields = ['quote_required', 'requote_required', 'customer_rated', 'sales_notation', 'management_notation'];
    const admin_fields = ['po_audited', 'confirm_charges', 'freight_cost_approved', 'ready_invoice', 'intent_claim', 'invoice_thanks', 'pod_audited',
      'carrier_invoiced', 'freight_cost_exception', 'damage_claim', 'claim_review', 'invoice_due', 'confirm_pickup', 'confirm_delivery', 'pod_required',
      'purchase_order_required', 'care_notation'];
    const ops_fields = ['carrier_rated', 'carrier_rerated', 'straps_bars', 'lift_lull', 'call_site', 'protective_equipment', 'unmanned_job_site', 'operations_notation',
      'loaded_odot', 'loading_delay', 'document_delay', 'border_delay', 'customs_inspection', 'trailer_unavailable', 'driver_unavailable', 'driver_hos', 'carrier_reneged',
      'mechanical_delay', 'trailer_switch', 'weather_delay', 'dock_waiting', 'dock_re_delivery', 'scheduled_holiday'];

    // set order summary info
    this.order_summary_forms.get('load_details')?.setValue(this.details.ladings.load_details);
    this.order_summary_forms.get('seal_number')?.setValue(this.details.ladings.seal_number);
    this.order_summary_forms.get('hot')?.setValue(this.details.ladings.hot);
    this.order_summary_forms.get('drop_trailer')?.setValue(this.details.ladings.drop_trailer);
    this.order_summary_forms.get('expedited')?.setValue(this.details.ladings.expedited);
    this.order_summary_forms.get('customer_po')?.setValue(this.details.ladings.customer_po);

    // set form fields for cares stuff
    if (this.details.lading_cares) {
      for (let i = 0; i < cares_fields.length; i++) {
        this.cares_forms.get(cares_fields[i])?.setValue(this.details.lading_cares[cares_fields[i]]);
      }
    }

    // set form fields for operations stuff
    if (this.details.lading_operations) {
      for (let i = 0; i < ops_fields.length; i++) {
        this.ops_forms.get(ops_fields[i])?.setValue(this.details.lading_operations[ops_fields[i]]);
      }
    }

    // set form fields for sales stuff
    if (this.details.lading_sales) {
      for (let i = 0; i < sales_fields.length; i++) {
        this.sales_forms.get(sales_fields[i])?.setValue(this.details.lading_sales[sales_fields[i]]);
      }
    }


    // set form fields for admin stuff
    for (let i = 0; i < admin_fields.length; i++) {
      this.admin_forms.get(admin_fields[i])?.setValue(this.details.lading_administrations[admin_fields[i]]);
    }

    // set site checks
    for (let i = 0; i < this.details.lading_site_checks.length; i++) {
      if (this.details.lading_site_checks[i].contact_type == 4) {
        this.setShipperFormControls(i);
        this.shipper_site_check_uuid = this.details.lading_site_checks[i].lading_site_check_uuid;
      }
      else if (this.details.lading_site_checks[i].contact_type == 2) {
        this.setConsigneeFormControls(i);
        this.consignee_site_check_uuid = this.details.lading_site_checks[i].lading_site_check_uuid;
      }
      else if (this.details.lading_site_checks[i].contact_type == 20) {
        this.setCustomerFormControls(i);
        this.customer_site_check_uuid = this.details.lading_site_checks[i].lading_site_check_uuid;
      }
    }
  }

  setCustomerFormControls(i: number) {
    let customer_site_checks = this.details.lading_site_checks[i];
    const customer_fields = ['bol_required', 'invoice_bol_required', 'rate_quote_required', 'invoice_po_required', 'invoice_po',
      'pickup_reference_number_required', 'delivery_reference_number_required'];
    for (let i = 0; i < customer_fields.length; i++) {
      this.customer_forms.get(customer_fields[i])?.setValue(customer_site_checks[customer_fields[i]])
    }
  }

  setConsigneeFormControls(i: number) {
    let consignee_site_checks = this.details.lading_site_checks[i];
    const consignee_fields = ['delivery_reference_number_required', 'delivery_reference_number', 'loading_dock', 'pickup_tailgate', 'truck_space',
      'appointment', 'call_site', 'commercial', 'residential', 'job_site', 'unmanned_job_site', 'convention_center', 'pop_up_store', 'job_site_contact_name',
      'job_site_contact_phone', 'appointment_contact_name', 'appointment_contact_phone', 'notification_at_pickup', 'notification_delayed_pickup',
      'notification_at_delivery', 'notification_delayed_delivery', 'notification_assessorials_incured'];
    for (let i = 0; i < consignee_fields.length; i++) {
      this.consignee_forms.get(consignee_fields[i])?.setValue(consignee_site_checks[consignee_fields[i]])
    }
  }

  setShipperFormControls(i: number) {
    let shipper_site_checks = this.details.lading_site_checks[i];
    const shipper_fields = ['pickup_reference_number_required', 'pickup_reference_number', 'loading_dock', 'pickup_tailgate', 'truck_space', 'appointment',
      'call_site', 'shipping_bol_required', 'commercial', 'residential', 'job_site', 'unmanned_job_site', 'job_site_contact_name', 'job_site_contact_phone',
      'appointment_contact_name', 'appointment_contact_phone', 'notification_at_pickup', 'notification_delayed_pickup', 'notification_at_delivery',
      'notification_delayed_delivery', 'notification_assessorials_incured'];
    for (let i = 0; i < shipper_fields.length; i++) {
      this.shipper_forms.get(shipper_fields[i])?.setValue(shipper_site_checks[shipper_fields[i]]);
    }
  }

  fetchAdditionalInfo() {
    console.log(this.apiUrl);
    this.http.get<any>(this.apiUrl).subscribe(response => {
      if (response.ladings) {
        this.details = response;
        this.lading_details = response.ladings;
        console.log(response)
        this.consignee_contact_uuid = response.ladings.consignee_contact_uuid;
      }
      // look for carrier in lading_tasks
      if (response.lading_tasks) {
        response.lading_tasks.forEach((element: any) => {
          if (element.task_type == "6") {
            this.new_carrier_forms.get('old_carrier_task_uuid')?.setValue(element.lading_task_uuid)
            console.log(`old carrier's task uuid is ${this.new_carrier_forms.get('old_carrier_task_uuid')?.value}`)
          }
        })
      }
      this.lading_statuses = response.status_timeline;
      this.fetchInstallationFormInfo();
      this.orderLadingStatusTimeline();
      this.setFormControlDates();
      this.setFormControlValues();
      this.setAddresses();
    })
  }

  // helper function - formats addresses
  buildAddress(address: any): string[] {
    let addressArray: string[] = [];
    addressArray[0] = address.address_street + (address.address_extended ? " " + address.address_extended : "");
    addressArray[1] = address.address_locality + ", " + address.address_region;
    addressArray[2] = address.address_country + " " + address.address_postal_code;
    return addressArray;
  }

  // yyyy-mm-dd --> mmm dd,yyyy
  // used to render status timeline
  formatDate(oldDate: string): string {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', "Dec"];
    let month = months[+oldDate.substring(5, 7) - 1];
    return `${month} ${oldDate.substring(8)}, ${oldDate.substring(0, 4)}`;
  }

  // for map button
  openMap() {
    if (this.addresses.consignee.length > 0) {
      let origin = `${this.addresses.shipper[0].replace("#", "")}, ${this.addresses.shipper[1]} ${this.addresses.shipper[2]}`;
      let destination = `${this.addresses.consignee[0].replace("#", "")}, ${this.addresses.consignee[1]} ${this.addresses.consignee[2]}`;
      window.open('/map/' + origin + '/' + destination, '_blank', 'popup,width=1280px,height=720px');
    }
    else {
      let contact_url = `/api/contacts/contact_addresses.php?uuid=${this.consignee_contact_uuid}`;
      this.http.get<any>(contact_url).subscribe(response => {
        if (response) {
          console.log('address found');
          console.log(`response from contact addresses: ${JSON.stringify(response)}`)
          // let address = ADDRESS_THING_HERE.replace('#','');
          // window.open('/map/' + address, '_blank', 'popup,width=1280px,height=720px');
        }
        else {
          console.log('no address found')
          console.log(`response from contact addresses: ${JSON.stringify(response)}`)
        }
      })
    }
  }

  // for full details page button
  openFullDetails() {
    window.open('/work_order_details/' + this.lading_uuid, '_blank');
  }

  // allow editing
  enableTabEditing() {
    this.edit_all_tabs = true;
    this.order_summary_forms.enable();
    this.ops_forms.enable();
    this.shipper_forms.enable();
    this.consignee_forms.enable();
    this.customer_forms.enable();
    this.sales_forms.enable();
    this.admin_forms.enable();
    this.cares_forms.enable();
    this.new_carrier_forms.enable();
    this.carrier_reneged_form.enable();
    this.disableEditing();
  }

  // keeps certain form controls disabled
  disableEditing() {
    // form controls to disable for shipper and consignee
    const form_controls = ['job_site_contact_name', 'job_site_contact_phone', 'appointment_contact_name', 'appointment_contact_phone',
      'notification_at_pickup', 'notification_delayed_pickup', 'notification_at_delivery', 'notification_delayed_delivery', 'notification_assessorials_incured'];
    for (let i = 0; i < form_controls.length; i++) {
      this.shipper_forms.get(form_controls[i])?.disable();
      this.consignee_forms.get(form_controls[i])?.disable();
    }
  }

  cancelEditing() {
    this.edit_all_tabs = false;
    this.order_summary_forms.disable();
    this.order_summary_forms.disable();
    this.ops_forms.disable();
    this.shipper_forms.disable();
    this.consignee_forms.disable();
    this.customer_forms.disable();
    this.sales_forms.disable();
    this.admin_forms.disable();
    this.cares_forms.disable();
    this.new_carrier_forms.disable();
    this.carrier_reneged_form.disable();
  }

  saveEditing() {
    this.cancelEditing(); // disable forms
    // if carrier has been selected, switch carrier
    if (this.carrier_selected_uuid != '') {
      this.submitNewCarrier();
    }
    if (this.carrier_reneged_form.get('did_carrier_reneged')?.value) {

      let reason_num: number = this.carrier_reneged_form.get('carrier_reneged_reason')?.value as number;

      console.log(`carrier reneged.`);
      if (reason_num !== null && reason_num !== undefined) {
        if (reason_num > 0) {
          let renegePostData = {
            lading_uuid: this.lading_uuid,
            carrier_contact_uuid: this.lading_details.carrier_contact_uuid,
            reason: reason_num
          }
          let renegeUrl = '/api/work_orders/add_reneged_carrier.php';
          this.http.post<any>(renegeUrl, renegePostData).subscribe(response => {
            console.log(response)
          },
            err => {
              console.error(err)
            });


        }
      }
    }
    let postData: any = {
      ladings: {
        lading_uuid: this.lading_uuid
      },
      lading_cares: {
        lading_care_uuid: this.details.lading_cares.lading_care_uuid,
        lading_uuid: this.lading_uuid
      },
      lading_administrations: {
        lading_administration_uuid: this.details.lading_administrations.lading_administration_uuid,
        lading_uuid: this.lading_uuid
      },
      lading_operations: {
        lading_operation_uuid: this.details.lading_operations.lading_operation_uuid,
        lading_uuid: this.lading_uuid
      },
      lading_sales: {
        lading_sale_uuid: this.details.lading_sales.lading_sale_uuid,
        lading_uuid: this.lading_uuid
      },
      lading_site_checks: [
      ]
    }

    // i should use a big for loop and a map or something for the below instead...

    //except for these.
    if (this.order_summary_forms.get('load_details')?.value !== this.lading_details.load_details)
      postData.ladings.load_details = this.order_summary_forms.get('load_details')?.value;
    if (this.order_summary_forms.get('seal_number')?.value !== this.lading_details.seal_number) {
      postData.ladings.seal_number = this.order_summary_forms.get('seal_number')?.value;
    }
    if (this.order_summary_forms.get('load_start_date')?.dirty || this.order_summary_forms.get('load_start_time')?.dirty) {
      console.log('load start has been edited')
      postData.ladings.load_start = this.convertDateTime(this.order_summary_forms.get('load_start_date'), this.order_summary_forms.get('load_start_time'));
    }
    if (this.order_summary_forms.get('load_end_date')?.dirty || this.order_summary_forms.get('load_end_time')?.dirty) {
      console.log('load end has been edited')
      postData.ladings.load_end = this.convertDateTime(this.order_summary_forms.get('load_end_date'), this.order_summary_forms.get('load_end_time'));
    }
    if (this.order_summary_forms.get('hot')?.dirty) {
      postData.ladings.hot = this.order_summary_forms.get('hot')?.value ? this.order_summary_forms.get('hot')?.value : null;
    }
    if (this.order_summary_forms.get('expedited')?.dirty) {
      postData.ladings.expedited = this.order_summary_forms.get('expedited')?.value ? this.order_summary_forms.get('expedited')?.value : null;
    }
    if (this.order_summary_forms.get('drop_trailer')?.dirty) {
      postData.ladings.drop_trailer = this.order_summary_forms.get('drop_trailer')?.value ? this.order_summary_forms.get('drop_trailer')?.value : null;
    }
    // console.log(`edited pickup date is ${this.order_summary_forms.get('load_start_date')?.value}`)
    // console.log(`edited pickup time is ${this.order_summary_forms.get('load_start_time')?.value}`)
    // console.log(`original pickup is ${this.lading_details.load_start} and it is a ${typeof this.lading_details.load_start}`)



    // Ship section
    let shipper_data: any = {};
    shipper_data.lading_uuid = this.lading_uuid;
    shipper_data.contact_type = 4; //4 represents 'shipper'
    shipper_data.contact_uuid = this.lading_details.shipper_contact_uuid;
    // Include lading_site_check_uuid if it exists
    if (this.shipper_site_check_uuid) {
      shipper_data.lading_site_check_uuid = this.shipper_site_check_uuid;
    }

    // Collect form data
    Object.assign(shipper_data, this.shipper_forms.value);

    // Push to postData
    postData.lading_site_checks.push(shipper_data);

    // Consignee section
    let consignee_data: any = {};
    consignee_data.lading_uuid = this.lading_uuid;
    consignee_data.contact_type = 2; //2 represents 'consignee'
    consignee_data.contact_uuid = this.lading_details.consignee_contact_uuid;

    if (this.consignee_site_check_uuid) {
      consignee_data.lading_site_check_uuid = this.consignee_site_check_uuid;
    }

    Object.assign(consignee_data, this.consignee_forms.value);

    postData.lading_site_checks.push(consignee_data);

     
    //  let shipper_data: any = {};
    //  shipper_data.lading_uuid = this.lading_uuid;
    //  shipper_data.contact_type = 4; 
    //  let isShipperEdited = false;
 
    //  Object.keys(this.shipper_forms.controls).forEach(key => {
    //    if (this.shipper_forms.get(key)?.dirty) {
    //      isShipperEdited = true;
    //      if (typeof this.shipper_forms.get(key)?.value === 'boolean' && !this.shipper_forms.get(key)?.value)
    //        shipper_data[key] = null;
    //      else
    //        shipper_data[key] = this.shipper_forms.get(key)?.value;
    //    }
    //  });
 
    //  if (this.shipper_site_check_uuid) {
    //    shipper_data.lading_site_check_uuid = this.shipper_site_check_uuid;
    //  } else if (isShipperEdited) {
    //    shipper_data.lading_site_check_uuid = null; // Let the backend generate a new UUID
    //  }
 
    //  if (isShipperEdited) {
    //    postData.lading_site_checks.push(shipper_data);
    //  }
 
    //  let consignee_data: any = {};
    //  consignee_data.lading_uuid = this.lading_uuid;
    //  consignee_data.contact_type = 2; 
    //  let isConsigneeEdited = false;
 
    //  Object.keys(this.consignee_forms.controls).forEach(key => {
    //    if (this.consignee_forms.get(key)?.dirty) {
    //      isConsigneeEdited = true;
    //      if (typeof this.consignee_forms.get(key)?.value === 'boolean' && !this.consignee_forms.get(key)?.value)
    //        consignee_data[key] = null;
    //      else
    //        consignee_data[key] = this.consignee_forms.get(key)?.value;
    //    }
    //  });
 
    //  if (this.consignee_site_check_uuid) {
    //    consignee_data.lading_site_check_uuid = this.consignee_site_check_uuid;
    //  } else if (isConsigneeEdited) {
    //    consignee_data.lading_site_check_uuid = null; // Let the backend generate a new UUID
    //  }
 
    //  if (isConsigneeEdited) {
    //    postData.lading_site_checks.push(consignee_data);
    //  }

    let customer_data: any = {};
    customer_data.lading_site_check_uuid = this.customer_site_check_uuid;
    customer_data.lading_uuid = this.lading_uuid;
    let isCustomerEdited = false;
    Object.keys(this.customer_forms.controls).forEach(key => {
      if (this.customer_forms.get(key)?.dirty) {
        isCustomerEdited = true;
        if (typeof this.customer_forms.get(key)?.value === 'boolean' && !this.customer_forms.get(key)?.value)
          customer_data[key] = null;
        else
          customer_data[key] = this.customer_forms.get(key)?.value;
      }
    })
    if (isCustomerEdited) {
      postData.lading_site_checks.push(customer_data);
    }


    Object.keys(this.ops_forms.controls).forEach(key => {
      let controlVal = this.ops_forms.get(key)?.value;
      const apiVal = this.details.lading_operations[key];
      // convert any falses to nulls to match database formatting
      if (typeof controlVal === 'boolean' && !controlVal)
        controlVal = null;

      if (controlVal !== apiVal)
        postData.lading_operations[key] = controlVal;
    })
    // if user switched carriers because carrier reneged, set carrier_reneged to true
    if (this.carrier_reneged_form.get('did_carrier_reneged')?.value) {
      postData.lading_operations.carrier_reneged = true;
    }

    Object.keys(this.sales_forms.controls).forEach(key => {
      let controlVal = this.sales_forms.get(key)?.value;
      const apiVal = this.details.lading_sales[key];
      if (typeof controlVal === 'boolean' && !controlVal)
        controlVal = null;
      if (controlVal !== apiVal)
        postData.lading_sales[key] = controlVal;
    })

    Object.keys(this.cares_forms.controls).forEach(key => {
      let controlVal = this.cares_forms.get(key)?.value;
      const apiVal = this.details.lading_cares[key];
      if (typeof controlVal === 'boolean' && !controlVal)
        controlVal = null;

      if (controlVal !== apiVal) {
        postData.lading_cares[key] = controlVal;
      }
    })

    Object.keys(this.admin_forms.controls).forEach(key => {
      let controlVal = this.admin_forms.get(key)?.value;
      const apiVal = this.details.lading_administrations[key];
      if (typeof controlVal === 'boolean' && !controlVal)
        controlVal = null;

      if (controlVal !== apiVal)
        postData.lading_administrations[key] = controlVal;
    })
    
    this.http.post<any>(this.apiUrl, postData).subscribe(
      response => {
        console.log(response);
        console.log(postData);
    
        // Check response for errors
        const hasError = response.some((res: any) => res.action === 'Error');
        if (hasError) {
          this.toastr.error('Error saving data.');
        } else {
          this.toastr.success('Saved successfully!');
        }
      },
      err => {
        console.error(err);
        this.toastr.error('Error saving data.');
      }
    );
  }


  // convert edited date and time into a string before posting
  convertDateTime(date: any, time: any) {
    console.log(`date is ${date?.value} and it is a ${typeof date?.value}`)
    let hours: number;
    let minutes: number;
    // edited times in this format: 9:30 PM
    if (time.dirty) {
      hours = +time?.value.substring(0, time?.value.indexOf(':')) + (+time?.value.includes('P') ? 12 : 0);
      minutes = +time?.value.substring(time?.value.indexOf(':') + 1, time?.value.indexOf(':') + 3);
    }
    // unedited times are in this format: 21:30
    else {
      hours = +time?.value.substring(0, 2)
      minutes = +time?.value.substring(3);
    }

    date?.value.setHours(hours);
    date?.value.setMinutes(minutes);
    return date?.value.toISOString().substring(0, 19).replace('T', ' ');
  }


  printLabel(doc_type: string): void {
    let endpoint = '';
  
    switch (doc_type) {
      case 'packing':
        endpoint = `/api/work_orders/print_pdfs/newams_print_packing_label.php`;
        break;
      case 'pallet':
        endpoint = `/api/work_orders/print_pdfs/newams_print_pallet_label.php`;
        break;
      case 'bol':
        endpoint = `/api/work_orders/print_pdfs/newams_print_bol.php`;
        break;
      case 'trailer':
        endpoint = `/api/work_orders/print_pdfs/newams_print_trailer_label.php`;
        break;
      default:
        return;
    }
  
    this.http.get(endpoint, {
      responseType: 'blob', // Expect binary data
      params: { uuid: this.lading_uuid }
    }).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      // Optionally revoke the object URL after some time to free memory
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    });
  }

  // print function checks the string passed to determine which document is printed in the new tab
  printBOL(uuid: string, alternate_reference: string, shipper_contact_uuid: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '405px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Print Bill Of Lading',
        modalMessage: {lading_uuid: uuid, alternate_reference: alternate_reference, shipper_contact_uuid: shipper_contact_uuid},
      },
    };
    this.dialog.open(ShipmentListsModalComponent, dialogConfig);    
  }  
  
  printAll(): void {
    const endpoint = `/api/work_orders/combined_pdf.php`;
  
    this.http.get(endpoint, {
      responseType: 'blob',
      params: { trip_number: this.trip_number }
    }).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    });
  }

  orderLadingStatusTimeline() {
    this.lading_statuses.sort((a, b) => {
      const dateA = new Date(a.local_time ? a.local_time : a.created);
      const dateB = new Date(b.local_time ? b.local_time : b.created);
      return dateA.getTime() - dateB.getTime();
    })
  }

  /* Section for navigation to installation web server forms */

  // button links
  formButtons = {
    inservice: 'https://inservice.ulaap.com/',
    checklist: 'https://checklist.ulaap.com/',
    disclaimer: 'https://disclaimer.ulaap.com/',
    inagreement: 'https://inagreement.ulaap.com/',
    sitesurvey: 'https://sitesurvey.ulaap.com/'
  };
  
  // fetch token to lead to the installation form for the respective order
  fetchInstallationFormInfo() {
    this.http.get<any>(`/api/work_orders/installation_forms.php?uuid=${this.lading_uuid}`).subscribe(response => {
      if (response && Array.isArray(response)) {
        response.forEach(item => {
          switch (item.token_type) {
            case 'webapp':
              this.formButtons.inservice = `${this.formButtons.inservice}?token=${item.token}`;
              this.formButtons.checklist = `${this.formButtons.checklist}?token=${item.token}`;
              this.formButtons.disclaimer = `${this.formButtons.disclaimer}?token=${item.token}`;
              this.formButtons.sitesurvey = `${this.formButtons.sitesurvey}?token=${item.token}`;
              break;
            case 'consignee':
              this.formButtons.inagreement = `${this.formButtons.inagreement}?token=${item.token}`;
              break;
          }
        });
      }
    });
  }


  // open form in new window
  navigateTo(url: string) {
    window.open(url, '_blank');
  }


  refresh(params: any): boolean {
    return true;
  }
}

interface Addresses {
  shipper: string[],
  consignee: string[],
}

interface LadingStatus {
  lading_status: string,
  created: string,
  local_time: string | null
}
